import { useEffect, useState } from 'react';
import { CHART_GROW_DURATION_MS } from '../ReferralPerformanceDashboard/chartAnimation';

function easeOutCubic(t) {
  return 1 - (1 - t) ** 3;
}

export function useAnimatedNumber(target, {
  duration = CHART_GROW_DURATION_MS,
  delay = 0,
  decimals = 0,
  enabled = true,
} = {}) {
  const numTarget = target == null || target === '' || Number.isNaN(Number(target))
    ? null
    : Number(target);
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!enabled || numTarget == null) {
      setValue(numTarget ?? 0);
      return undefined;
    }

    setValue(0);
    let frame;
    let startTime;
    const timeout = setTimeout(() => {
      const tick = (timestamp) => {
        if (startTime == null) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const eased = easeOutCubic(progress);
        const current = numTarget * eased;

        if (decimals > 0) {
          setValue(Number(current.toFixed(decimals)));
        } else {
          setValue(Math.round(current));
        }

        if (progress < 1) {
          frame = requestAnimationFrame(tick);
        }
      };
      frame = requestAnimationFrame(tick);
    }, delay);

    return () => {
      clearTimeout(timeout);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [numTarget, duration, delay, decimals, enabled]);

  return { value, isEmpty: numTarget == null };
}
